import * as Yup from 'yup'

import flow from 'lodash/fp/flow'

import email from '@galo-monitor/forms/validators/email.validator'
import equal from '@galo-monitor/forms/validators/equal.validator'
import phone from '@galo-monitor/forms/validators/phone.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const userSchema = ({ t, data }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  phone: flow(
    phone({ t }),
    required({ t })
  )(Yup.string()),
  email: flow(
    email({ t }),
    required({ t })
  )(Yup.string()),
  email_confirmation: flow(
    equal({ t, text: 'emails do not match', compareWith: data.email }),
    required({ t })
  )(Yup.string()),
  company_role_id: required({ t })(Yup.string()),
  company_role_position: required({ t })(Yup.string()),
  farms_always: Yup.string(),
  farms: (() => {
    let instance = Yup.array().of(
      Yup.string()
    ).nullable()

    if (data.farms_always === 'custom') {
      instance = required({ t, isNotText: true })(instance)
    }
    return instance
  })()
})

export default userSchema
